import React from "react";
import YouTube from "react-youtube";
import "../assets/css/Afiliado.css";
import Footer from "./footer";

const videoOpts = {
  playerVars: {
    autoplay: 0,
  },
};
const logobranca = `${process.env.PUBLIC_URL}/LOGOBRANCO.png`;
const todapage = `${process.env.PUBLIC_URL}/pageafiliados/TodaPage.png`;
const partedecima = `${process.env.PUBLIC_URL}/pageafiliados/top.png`;
const partedemeio = `${process.env.PUBLIC_URL}/pageafiliados/midle.png`;
const partedebaixo = `${process.env.PUBLIC_URL}/pageafiliados/botton.png`;
const Afilhado = () => {
  return (
    <div className="limiterafiliados">
      <div className="sitecanva">
        <iframe
          loading="lazy"
          className="inframecanva"
          src="https:&#x2F;&#x2F;
www.canva.com
&#x2F;design&#x2F;DAFw0EIs0mc&#x2F;view?embed"
          allowfullscreen="allowfullscreen"
          allow="fullscreen"
        ></iframe>
      </div>

      <Footer />
    </div>
  );
};

export default Afilhado;
